function setCookie(cname, cvalue) {
  var d = new Date(Date.now() + 3650 * 24 * 60 * 60 * 1000);
  let expires = "expires="+ d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for(let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}


$(".trigger").click(function(){
  $(".modal").addClass("show-modal");
});
$(".close-button").click(function(){
  $(".modal").removeClass("show-modal");
});


function autochangeLocation(obj){
if (navigator.geolocation) {
    navigator.geolocation.getCurrentPosition(showPosition, showError);
  } 
}

function changeLocation(obj){
  /* var city = $(obj).siblings("#city_dropdown").find(":selected").text();
  var city_code = $(obj).siblings("#city_dropdown").val(); */
  var city = $(obj).find(":selected").text();
  var city_code = $(obj).val();
  console.log(city, city_code);
  SetLocation(city, city_code);
}

function showError(error) {
  switch(error.code) {
    case error.PERMISSION_DENIED:
      alert("User denied the request for Geolocation.");
      break;
    case error.POSITION_UNAVAILABLE:
      alert("Location information is unavailable.");
      break;
    case error.TIMEOUT:
      alert("The request to get user location timed out.");
      break;
    case error.UNKNOWN_ERROR:
      alert("An unknown error occurred.");
      break;
  }
} 

function showPosition(position) {
  let api_url = "https://apis.mappls.com/advancedmaps/v1/140e236841ebd047b66e1d59d64bc7d0/rev_geocode?lat=" + position.coords.latitude + "&lng=" + position.coords.longitude;
  $.get(api_url, function(data) {
    let api_city = data.results[0].city;
    if (api_city == "Bengaluru") api_city = "Bangalore";
    let default_city_code = "0";
    let default_city = "Rest of India";
    let city_dropdown = document.getElementById('city_dropdown');
    for (let _city of city_dropdown.options) {
      if (api_city == _city.text) {
        default_city_code = _city.value;
        default_city = _city.text;
      }
    }
    city_dropdown.value = default_city_code;
    SetLocation(default_city, default_city_code);
  });
}


function locationLogic(){
  var cookieLoc = getCookie("gcs_delivery_city");
  if(cookieLoc === ""){
    //myModal.open();
  }else{
    let city = JSON.parse(cookieLoc);                                  
    let city_code = city['city_code'];
    var cityname = city['city'];
    $("#ChnageLocat").text(cityname);
  }
}

function SetLocation(city, city_code){
  var object = {
    'city': city,
    'country': "India",
    'city_code' : city_code            
  };  
  setCookie("gcs_delivery_city",JSON.stringify(object)); 
  updateGridLocation();
  locationLogic();
  $(".modal").removeClass("show-modal");
  //window.location.reload();
}

const jsonObject = [
    271642165434,
    271642034362,
    271642722490,
    271642263738,
    271642362042,
    271714713786,
    397510377726,
    398104232190,
    271642624186,
    396536447230,
    405082276094,
    408581243134,
    271642624187
];

$(document).ready(function(){
  locationLogic();
  var cookieLoc = getCookie("gcs_delivery_city");
  let city,city_code;
  if(cookieLoc !== ""){
    city = JSON.parse(cookieLoc);                                  
    city_code = city['city_code'];
    let city_dropdown = document.getElementById('city_dropdown');
    city_dropdown.value = city_code || 0;
    console.log(city['city'],city_code);
  }  
});

setTimeout(updateGridLocation, 4000);

function updateGridLocation(){
  $(".grid-product,.pro-location").each(function(){
  var prod_collection = $(this).attr("data-col");
  var id = $(this).attr("data-product-id");
  let chk_flag = false;
  const prod_collections = prod_collection.split(",");
  prod_collections.splice(0,1);
      //console.log(prod_collections);
  for(var i=0; i< prod_collections.length; i++){
    if(jsonObject.includes(parseInt(prod_collections[i]))){
      chk_flag = true;
      break;
    }
  }
  if(chk_flag){
    let check_flag= false;

    var cookie_output = getCookie('gcs_delivery_city');
    if(cookie_output != "")
    {
      let city = JSON.parse(cookie_output);                                  
      let city_code = city['city_code'];
      var cityname = city['city'];
      
      for(var i=0; i< prod_collections.length ; i++){
        let x = parseInt(prod_collections[i],10);
        if(x == parseInt(city_code,10))
        {
          check_flag = true;
          break;
        }
      }
    }
    if(check_flag === false){
      $("#product_"+id).addClass("disabledbutton");
      $("#product_"+id).find(".product-form__buttons").hide();
      $("#product_"+id).find(".quick-add__submit").hide();
      if(cityname != undefined){
        $("#product_"+id).find(".locAvlgcs").html("Not Available In "+ cityname);
      }else{
        $("#product_"+id).find(".locAvlgcs").html("Choose a location");
      }
    }else if(check_flag === true){
      $("#product_"+id).removeClass("disabledbutton");
      $("#product_"+id).find(".product-form__buttons").show();
      $("#product_"+id).find(".quick-add__submit").show();
      $("#product_"+id).find(".locAvlgcs").html("");
    }
  }
});
}

updateGridLocation();

document.addEventListener('collection:reloaded', function() {
  updateGridLocation();
});